var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Inset from 'syf-component-library/ui/spacing/Inset';
import Stack from 'syf-component-library/ui/spacing/Stack';
import useTranslation from '../../../../hooks/use-translation';
import { StyledFlex, StyledText } from '../../../subcomponents';
import { LeavingSimpleModalPortal, StyledButton, StyledTextbox } from './subcomponents';
import { useMainContext } from '../../../../context';
import useTriggerAnalyticsEvent from '../../../../helpers/triggerAnalyticsEvent';
import { getButtonAnalytics } from '../../../../helpers/getAnalytics';
export var LeavingModal = function (_a) {
    var closeModal = _a.closeModal, isOpen = _a.isOpen, onCleanup = _a.onCleanup;
    var i18n = useTranslation();
    var NFCC_URL = 'https://nfcc.org/synchrony-de';
    var currentRoute = useMainContext().currentRoute;
    useTriggerAnalyticsEvent({
        featureEvent: 'leaving',
        currentRoute: currentRoute,
        shouldTrigger: isOpen
    });
    var dataType = getButtonAnalytics(currentRoute).dataType;
    var onClickHandler = function () {
        closeModal();
    };
    useEffect(function () {
        return function () {
            onCleanup();
        };
    }, [onCleanup]);
    return (_jsx(LeavingSimpleModalPortal, __assign({ "aria-labelledby": "modal-title", containerId: "nfcc-container", isOpen: isOpen, id: "external-link-modal", escapeModalHandler: closeModal }, { children: _jsx(Inset, __assign({ all: "large" }, { children: _jsxs(StyledFlex, __assign({ direction: "column", justifyContent: "center", alignItems: "center" }, { children: [_jsx(Stack, { size: "medium" }), _jsx(StyledText, __assign({ id: "modal-title", align: "center", size: "medium", weight: "bold" }, { children: i18n('common.leavingContactHeading') })), _jsx(Stack, { size: "large" }), _jsx(StyledButton, __assign({ buttonType: "primary", forwardedAs: "a", href: NFCC_URL, onClick: onClickHandler, rel: "noopener noreferrer", target: "_blank", "data-type": dataType, "data-reason": "yes open in a new tab", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: i18n('common.openButton') })), _jsx(StyledButton, __assign({ buttonType: "secondary", onClick: onClickHandler, "data-type": dataType, "data-reason": "no go back", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: i18n('common.backButton') })), _jsx(Stack, { size: "large" }), _jsx(StyledTextbox, { children: _jsx(Inset, __assign({ all: "medium" }, { children: _jsx(StyledText, __assign({ size: "small", lineHeight: 1.6 }, { children: i18n('common.leavingContactDisclosureText') })) })) })] })) })) })));
};
export default LeavingModal;
//# sourceMappingURL=index.js.map